module.exports = __webpack_public_path__ + "static/apple_splash_750-eea24c7c68f46774fd5aebaef797d7cb.png";